import React from 'react'
import { getImages } from '../Common/const';
import RangeSlider from "react-range-slider-input";
import "react-range-slider-input/dist/style.css";

const MoreFilterModal = ({
    close,
    numberFormatter,
    handlePriceSliderChange,
    handleMileageSliderChange,
    handleInputChange,
    priceFilterData,
    mileageFilterData,
    handleClearAll,
    isMobile,
}) => {
    console.log("mileageFilterData", mileageFilterData)
    console.log("priceFilterData", priceFilterData)
    return (
        <>
            <div className="modal-content">
                {isMobile &&
                    <div className="modal-header">
                        <h1 className="modal-title filter-modal-title text-uppercase font-1-2em fw-300 w-100 text-center">
                            Refine Search
                        </h1>
                        <button className="sm-box-close" type="button" onClick={close}>
                            <img src={getImages('white-close.svg')} />
                        </button>
                    </div>
                }
                <div className="modal-body px-md-5 py-md-5 px-3 py-4">
                    {!isMobile && (
                        <>
                            <h1 className="modal-title filter-modal-title fw-300 text-uppercase font-1-9em mb-5">
                                Refine your Search
                            </h1>
                            <button className="sm-box-close" type="button" onClick={close}>
                                <img src={getImages('white-close.svg')} />
                            </button>
                        </>
                    )}
                    <div className='mt-md-4 d-md-flex rys-row gx-3'>
                        <div className='rys-col-1'>
                            <div className='more-filter-box'>
                                <div className='xs-title'>Price Range</div>
                                <div className='price-range-slider'>
                                    <RangeSlider
                                        value={[priceFilterData.current_min, priceFilterData.current_max]}
                                        onInput={handlePriceSliderChange}
                                        min={priceFilterData.min}
                                        max={priceFilterData.max}
                                    />
                                    <div className='d-flex align-items-center justify-content-between pr-labels'>
                                        <div>{numberFormatter(priceFilterData.min, true)}</div>
                                        <div>{numberFormatter(priceFilterData.max, true)}</div>
                                    </div>
                                    <div className='d-flex align-items-center justify-content-between mt-3'>
                                        <div>
                                            <input
                                                type="text"
                                                value={priceFilterData.current_min == priceFilterData.min ? "Min" : numberFormatter(priceFilterData.current_min, true)}
                                                className='pr-input-field'
                                                onChange={(e) => handleInputChange(0, e)}
                                            />
                                        </div>
                                        <div>
                                            <input
                                                type="text"
                                                value={priceFilterData.current_max == priceFilterData.max ? "Max" : numberFormatter(priceFilterData.current_max, true)}
                                                className='pr-input-field'
                                                onChange={(e) => handleInputChange(1, e)}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='rys-col-1'>
                            <div className='more-filter-box'>
                                <div className='xs-title'>Miles Range</div>
                                <div className='price-range-slider'>
                                    <RangeSlider
                                        value={[mileageFilterData.current_min, mileageFilterData.current_max]}
                                        onInput={handleMileageSliderChange}
                                        min={mileageFilterData.min}
                                        max={mileageFilterData.max}
                                    />
                                    <div className='d-flex align-items-center justify-content-between pr-labels'>
                                        <div>{numberFormatter(mileageFilterData.min)}</div>
                                        <div>{numberFormatter(mileageFilterData.max)}</div>
                                    </div>
                                    <div className='d-flex align-items-center justify-content-between mt-3'>
                                        <div>
                                            <input
                                                type="text"
                                                value={mileageFilterData.current_min == mileageFilterData.min ? "Min" : numberFormatter(mileageFilterData.current_min)}
                                                className='pr-input-field'
                                                onChange={(e) => handleInputChange(0, e)}
                                            />
                                        </div>
                                        <div>
                                            <input
                                                type="text"
                                                value={mileageFilterData.current_max == mileageFilterData.max ? "Max" : numberFormatter(mileageFilterData.current_max)}
                                                className='pr-input-field'
                                                onChange={(e) => handleInputChange(1, e)}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='text-center mt-md-5 mt-5'>
                        <button className="fl-transparent-btn text-uppercase me-md-4 me-0" type="button" onClick={handleClearAll}>Clear All</button>
                        <button className="white-btn text-uppercase" type="button" onClick={close}>View Matches</button>
                    </div>
                </div>
            </div>
        </>
    )
}

export default MoreFilterModal